export default {
  landings: [],
};
